import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { Component } from 'react';
import { colorWithOpacityToHex } from '../../../../utils/color';
import * as style from './Station.css';
export var Station = /*#__PURE__*/function (_Component) {
  _inherits(Station, _Component);

  var _super = _createSuper(Station);

  function Station() {
    var _this;

    _classCallCheck(this, Station);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function () {
      if (_this.props.isSelected) {
        _this.props.onRemove([Number(_this.props.data.id)]);
      } else {
        _this.props.onSelect([Number(_this.props.data.id)]);
      }
    });

    return _this;
  }

  _createClass(Station, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var stations = this.props.data.points.map(function (point, index) {
        return renderStation(point, _this2.props.data.name + index, _this2.props.isSelected, _this2.props.isHovered, _this2.props.isUnderConstruction);
      });
      return /*#__PURE__*/React.createElement("g", {
        onClick: this.clickHandler,
        onMouseEnter: function onMouseEnter() {
          return _this2.props.onHover([Number(_this2.props.data.id)]);
        },
        onMouseLeave: this.props.onLeave
      }, stations);
    }
  }]);

  return Station;
}(Component);

function renderStation(point, key, isSelected, isHovered, isUnderConstruction) {
  return /*#__PURE__*/React.createElement("g", {
    transform: "translate(".concat(point.x, " ").concat(point.y, ")"),
    key: key
  }, isSelected ? renderSelectedStation() : /*#__PURE__*/React.createElement("g", null, isHovered && /*#__PURE__*/React.createElement("circle", {
    cy: "0",
    cx: "0",
    r: "5.5",
    fill: point.fill,
    stroke: point.fill,
    filter: "url(#metroStationBlur)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: style['circle'],
    cy: "0",
    cx: "0",
    r: "5.5",
    stroke: isUnderConstruction ? colorWithOpacityToHex(point.fill, 0.5) : point.fill
  })), point.text && renderStationName(point.text, point.rectangle, isSelected, isHovered));
}

function renderSelectedStation() {
  return /*#__PURE__*/React.createElement("g", {
    className: style['selected_station']
  }, /*#__PURE__*/React.createElement("circle", {
    cy: "0",
    cx: "0",
    r: "6.75",
    stroke: "#ff7f00"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "-3 0.2 -1 2.2 3 -1.8"
  }));
}

function renderStationName(textData, rectangle, isSelected, isHovered, isUnderConstruction) {
  return /*#__PURE__*/React.createElement("g", {
    transform: "translate(".concat(textData.x, " ").concat(textData.y, ")"),
    opacity: isUnderConstruction && !isSelected ? 0.5 : 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "-9",
    width: rectangle.width,
    height: rectangle.height,
    className: isSelected ? style['selected'] : undefined
  }), /*#__PURE__*/React.createElement("text", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: textData.value
    },
    className: "".concat(style['station_name'], " ").concat(isHovered ? style['station_name--hover'] : '')
  }));
}